import { PropsWithChildren } from 'react';

import { RoundButtonType } from './types';

import * as S from './styled';

const RoundButton = ({
    onClick,
    size = 44,
    children,
    disabled = false,
    dataTestId,
}: PropsWithChildren<RoundButtonType>) => {
    return (
        <S.Button type="button" onClick={onClick} size={size} disabled={disabled} data-testid={dataTestId}>
            {children}
        </S.Button>
    );
};

export default RoundButton;
